<style lang="scss" scope>
.mr1 {
  min-width: 20px;
  margin-right: 1rem;
}
.flexs {
  display: flex !important;
  width: 20%;
}
//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="">

      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <p>场所类型：</p>
          <el-row>
            <el-button type="info" :class="{active:search_data.type==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type">{{item.name}}</el-button>
          </el-row>

        </div>
      </div>

      <div class="flex justify-between items-center ivu-mt ivu-mb">

        <div class="flexs items-center">
          <span style="min-width:50px;">日期：</span>
          <div class="l-show-more-search">
            <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
            </el-date-picker>
          </div>
        </div>
        <l-auth-button type="primary" auth="place_census_export_btn" icon="el-icon-download" @click="handleExport">
          导出
        </l-auth-button>

      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{row[item.prop]}}
        </template>
      </el-table-column>
    </l-table>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      value1: '',
      data: [],
      count: 0,
      loading: false,
      place_type_list: [],
      search_data: {
        start_time: '',
        end_time: '',
        type: 1,
      },
      rel_search_data: {},
      show_more_search: false,
      value2: '',
      //默认
    };
  },
  computed: {
    columns() {
      let columns = [];
      if (this.search_data.type == 1) {
        columns = [
          {
            prop: "index",
            label: "序号",
            fixed: true,
            width: "100",
          },
          {
            prop: "type_name",
            label: "场所类型",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_count",
            label: "场所数（家）",
            fixed: true,
            minWidth: "100",
          },

          {
            prop: "place_check_count",
            label: "排查场所（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_hidden_count",
            label: "隐患场所（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_rectify_count",
            label: "整改场所（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_rate_count",
            label: "场所整改率",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_count",
            label: "隐患数（条）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_rectify_count",
            label: "整改隐患数（条）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_rate_count",
            label: "整改率",
            fixed: true,
            minWidth: "100",
          },
        ];
      } else if (this.search_data.type == 4 || this.search_data.type == 5) {
        columns = [
          {
            prop: "index",
            label: "序号",
            fixed: true,
            width: "100",
          },
          {
            prop: "community_name",
            label: "主管部门",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_count",
            label: "场所数",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_check_count",
            label: "完成排查(家)",
            fixed: true,
            minWidth: "100",
          },

          {
            prop: "place_hidden_count",
            label: "隐患场所（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_rectify_count",
            label: "整改场所（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_rectify_rate",
            label: "场所整改率",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_count",
            label: "隐患数",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_rectify_count",
            label: "整改隐患数（现场复查+预审通过)",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "total_progress",
            label: "总进度",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_rectify_count",
            label: "现场复查整改隐患数",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "pretrial_state_count",
            label: "预审通过隐患数（当前存量",
            fixed: true,
            minWidth: "100",
          },
        ];
      } else {
        columns = [
          {
            prop: "index",
            label: "序号",
            fixed: true,
            width: "100",
          },
          {
            prop: "community_name",
            label: "社区",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_count",
            label: "场所数",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_check_count",
            label: "排查场所数（家）",
            fixed: true,
            minWidth: "100",
          },

          {
            prop: "place_hidden_count",
            label: "隐患场所数（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_rectify_count",
            label: "已完成整改（家）",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "place_rectify_rate",
            label: "场所整改率",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_count",
            label: "隐患数",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_rectify_count",
            label: "整改隐患数（现场复查+预审通过)",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "total_progress",
            label: "总进度",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "hidden_rectify_count",
            label: "现场复查整改隐患数",
            fixed: true,
            minWidth: "100",
          },
          {
            prop: "pretrial_state_count",
            label: "预审通过隐患数（当前存量",
            fixed: true,
            minWidth: "100",
          },
        ];
      }
      return columns;
    },
  },

  watch: {
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
    //通过类型筛选
    placetype(id) {
      this.search_data.type = id;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("placeCensus_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索信息 

    getSearchData() {
      this.loading = true;
      this.$_invoke("placeCensus_getTotalRole", {
      })
        .then((ret) => {
          this.place_type_list = ret.place_type_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //导出
    handleExport() {
      this.export_loading = true;
      this.$_invoke('placeCensus_export', { ...this.search_data })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    }
  },
};
</script>
